import { render } from "./MyDrawerSingle.vue?vue&type=template&id=975287bc&scoped=true"
import script from "./MyDrawerSingle.vue?vue&type=script&lang=js"
export * from "./MyDrawerSingle.vue?vue&type=script&lang=js"

import "./MyDrawerSingle.vue?vue&type=style&index=0&id=975287bc&scoped=true&lang=scss"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-975287bc"]])

export default __exports__